var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { lg: _vm.lg, md: _vm.md, xs: "12" } },
    [
      _c(
        "w-card",
        [
          !_vm.crm.ContactID
            ? _c(
                "w-card-content",
                [_c("app-crm-select-contact", { attrs: { crm: _vm.crm } })],
                1
              )
            : _vm.crm.Contact
            ? _c(
                "w-card-content",
                [
                  _c(
                    "div",
                    { style: { display: "flex", flexDirection: "row" } },
                    [
                      _c("span", { staticClass: "contact" }, [
                        _vm._v(_vm._s(_vm.crm.Contact.getDisplayName())),
                      ]),
                    ]
                  ),
                  _vm.crm.Contact.MainAddress
                    ? [
                        _c("div", { staticClass: "address" }, [
                          _c("p", [
                            _vm._v(
                              _vm._s(_vm.crm.Contact.MainAddress.AddressLine1)
                            ),
                          ]),
                          _c("p", [
                            _vm._v(
                              _vm._s(_vm.crm.Contact.MainAddress.PostalAndCity)
                            ),
                          ]),
                        ]),
                        _vm.crm.Contact.MainAddress.getDefaultEmail()
                          ? _c(
                              "div",
                              { staticClass: "props email mt" },
                              [
                                _c(
                                  "w-link",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: _vm.$ct("copy-email"),
                                        expression: "$ct('copy-email')",
                                      },
                                    ],
                                    staticClass: "w-link mrs",
                                    on: {
                                      click: function ($event) {
                                        _vm.copyEmail(
                                          _vm.crm.Contact.MainAddress.getDefaultEmail()
                                        )
                                      },
                                    },
                                  },
                                  [_c("w-fa", { attrs: { icon: "copy" } })],
                                  1
                                ),
                                _c(
                                  "a",
                                  {
                                    staticClass: "w-link",
                                    attrs: {
                                      href:
                                        "mailto:" +
                                        _vm.crm.Contact.MainAddress.getDefaultEmail(),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.crm.Contact.MainAddress.getDefaultEmail()
                                        )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c("div", { staticClass: "props phone mt" }, [
                          _c(
                            "a",
                            {
                              staticClass: "w-link",
                              attrs: { href: _vm.crm.Contact.getCleanPhone() },
                              on: {
                                click: function ($event) {
                                  return _vm.triggerPhone(
                                    _vm.crm.Contact.MainAddress.Phone
                                  )
                                },
                              },
                            },
                            [
                              _vm.crm.Contact.MainAddress.Phone
                                ? _c("w-fa", {
                                    staticClass: "mrs",
                                    attrs: { icon: "phone-square-alt" },
                                  })
                                : _vm._e(),
                              _vm._v(_vm._s(_vm.crm.Contact.MainAddress.Phone)),
                            ],
                            1
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "ml w-link",
                              attrs: { href: _vm.crm.Contact.getCleanMobile() },
                              on: {
                                click: function ($event) {
                                  return _vm.triggerPhone(
                                    _vm.crm.Contact.MainAddress.Mobile
                                  )
                                },
                              },
                            },
                            [
                              _vm.crm.Contact.MainAddress.Mobile
                                ? _c("w-fa", {
                                    staticClass: "mrs",
                                    attrs: { icon: "phone-square-alt" },
                                  })
                                : _vm._e(),
                              _vm._v(
                                _vm._s(_vm.crm.Contact.MainAddress.Mobile)
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _c(
            "w-card-actions",
            [
              _c(
                "w-link",
                {
                  staticClass: "sale-edit link",
                  attrs: { disabled: _vm.loadingEdit },
                  on: {
                    click: function ($event) {
                      return _vm.openEditContact()
                    },
                  },
                },
                [
                  _c("w-fa", { staticClass: "mrs", attrs: { icon: "pen" } }),
                  _vm._v(_vm._s(_vm.$ct("contact-edit-details")) + " "),
                ],
                1
              ),
              _c("w-spacer"),
              _c(
                "w-link",
                {
                  staticClass: "sale-edit link ml",
                  on: {
                    click: function ($event) {
                      return _vm.clearContact()
                    },
                  },
                },
                [
                  _c("w-fa", {
                    staticClass: "mrs",
                    attrs: { icon: "exchange-alt" },
                  }),
                  _vm._v(_vm._s(_vm.$ct("settings-edit")) + " "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card",
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("properties")))]),
          _c(
            "w-card-content",
            [
              _c("app-crm-edit-properties", {
                attrs: { crm: _vm.crm },
                on: {
                  save: function ($event) {
                    return _vm.save($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.editModal
        ? _c(
            "w-modal",
            {
              attrs: { "escape-close": "", "full-height": "" },
              model: {
                value: _vm.editModal,
                callback: function ($$v) {
                  _vm.editModal = $$v
                },
                expression: "editModal",
              },
            },
            [
              _c(
                "w-card",
                {
                  style: { maxWidth: "95%", top: "20px", alignSelf: "center" },
                },
                [
                  _c(
                    "w-card-title",
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$ct("contact-edit-details")) + " "
                      ),
                      _c("w-spacer"),
                      _c(
                        "w-link",
                        {
                          attrs: { white: "" },
                          on: {
                            click: function ($event) {
                              _vm.editModal = false
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "times" } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { style: { height: "calc(100vh - 180px)" } },
                    [
                      _c("app-edit-contact", {
                        attrs: { "drawer-button-disabled": "" },
                        on: {
                          save: function ($event) {
                            return _vm.onContactSaved()
                          },
                          cancel: function ($event) {
                            _vm.editModal = false
                          },
                        },
                        model: {
                          value: _vm.editContact,
                          callback: function ($$v) {
                            _vm.editContact = $$v
                          },
                          expression: "editContact",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }